<template>
  <div>404，抱歉~~您访问的资源未找到！！！<a-button @click="$router.back()" >返回</a-button> </div>
</template>

<script>
  export default {
    name: 'notFound',
  }
</script>
